module.exports = __webpack_public_path__ + "static/media/Buddy_Insurance_Brand.f4119fe4.PNG";